<template>
  <div id="login_container">
    <el-dialog
      width="500px"
      :append-to-body="true"
      :visible.sync="arrangeDialog"
      :show-close="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :before-close="close"
    >
      <img style="width: 1px; hight: 1px" :src="info.imageName" alt="" />
      <div :class="'image-box ' + (switchType === 1 ? 'show' : 'height0 fade')">
        <wxlogin
          :appid="appid"
          :scope="scope"
          :theme="style"
          :state="state"
          :redirect_uri="redirect_uri"
        ></wxlogin>
      </div>
      <div :class="'phoneBox ' + (switchType === 2 ? 'show' : 'height0 fade')">
        <div class="title" v-if="towShow">手机验证码登录</div>
        <div class="title" v-if="!towShow">首次登录绑定手机</div>
        <div class="content">
          <input class="input1" style="margin-top: 50px;margin-bottom: 30px;" v-model="state" placeholder="请输入您的手机号码"></input>
          <div class="codeBox">
            <input class="input2" v-model="code" placeholder="您的验证码"></input>
            <div v-if="!flag" class="btn1" @click="getCode">获取验证码</div>
            <div v-if="flag" class="btn1 btnFade">{{countDown}}</div>
          </div>
          <div class="btn2" @click="login">登录</div>
        </div>
      </div>
      <div v-if="switchType === 3">
           <el-image :src="info.imageName"></el-image>
      </div>
      <!-- 手机号登录暂时下线 -->
      <!-- <div v-if="towShow && switchType !== 3" @click="switchClick" class="switch">{{switchType === 1 ? switchText1 : switchText2}}</div> -->
      <div v-if="switchType !== 3" class="tips">为防止bug，建议使用chrome浏览器</div>
    </el-dialog>

  </div>
</template>

<script>
import {
  getLoginImage,
  postUserPhoneLoginCode,
  postStudentPhoneLogin,
} from "../../utils/api";
import wxlogin from "vue-wxlogin";
import urlencode from "urlencode";
import store from "../../store/index";
export default {
  components: { wxlogin },
  data() {
    return {
      appid: "wx1b363bc92ced1137",
      scope: "snsapi_login",
      style: "black",
      state: "",
      redirect_uri: urlencode(
        `https://www.jingyouxue.com${
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        }`
      ),
      // redirect_uri: urlencode(`https://www.jingyouxue.com${this.$route.query.redirect?this.$route.query.redirect:'/'}`),
      //登陆弹窗
      arrangeDialog: false,
      loginText: "",
      switchType: 1,
      switchText1: "使用手机号登录>>>",
      switchText2: "使用微信登录>>>",
      phone: "",
      countDown: 60,
      flag: false,
      code: "",
      towShow: true,
      info: null,
    };
  },
  created() {
    if (+localStorage.getItem("phoneBindState") === 1) {
      this.towShow = false;
      this.arrangeDialog = true;
      this.switchType = 2;
    } else {
      if(!localStorage.getItem('showLoginImg')) {
        // this.arrangeDialog = true
        // this.switchType = 3;
      }
    }
    this.getLoginImageFn();
    console.log(
      this.$route.query.redirect,
      this.redirect_uri,
      "login页面重定向地址"
    );
    // let _str = this.$route.query.redirect;
    // this.redirect_uri = encodeURI(`https://www.jingyouxue.com${_str}`)
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    close() {
      this.arrangeDialog = false
      if(this.switchType === 3) {
        this.switchType = 1
        localStorage.setItem("showLoginImg", 1);
      }
    }, 
    getLoginImageFn() {
      getLoginImage().then((e) => {
        this.info = e.data;
      });
    },
    switchClick() {
      this.switchType = this.switchType === 1 ? 2 : 1;
    },
    getCode() {
      if (!this.state) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.flag) return;
      this.flag = true;
      let tiemr = setInterval(() => {
        if (this.countDown === 1) {
          this.flag = false;
          this.countDown = 60;
          clearInterval(tiemr);
        }
        this.countDown--;
      }, 1000);
      postUserPhoneLoginCode({
        phone: this.state,
      });
    },
    login() {
      if (!this.state) {
        this.$message.error("请输入手机号");
        return;
      }
      if (!this.code) {
        this.$message.error("请输入验证码");
        return;
      }
      postStudentPhoneLogin({
        phone: this.state,
        code: this.code,
      }).then((e) => {
        if (e.data.start === 0) {
          localStorage.setItem("phoneBindState", 0);
          localStorage.setItem(
            "userOpenid",
            e.data.weChatOpenAccessTokenVo.userOpenid
          );
          localStorage.setItem(
            "nickname",
            e.data.weChatOpenAccessTokenVo.userInfo.nickname
          );
          localStorage.setItem(
            "headimgurl",
            e.data.weChatOpenAccessTokenVo.userInfo.headimgurl
          );
          // 登陆后显示头像名字
          store.state.headimgurl =
            e.data.weChatOpenAccessTokenVo.userInfo.headimgurl;
          store.state.nickname =
            e.data.weChatOpenAccessTokenVo.userInfo.nickname;
          store.state.userOpenid =
            e.data.weChatOpenAccessTokenVo.userInfo.userOpenid;
          this.$message({
            message: "登录成功！",
            type: "success",
          });
          this.arrangeDialog = false;
          return
          if(localStorage.getItem('showLoginImg') == 1) {
            this.arrangeDialog = false;
          } else {
            // this.switchType = 3;
          }
          this.clearURLParams();
          // location.reload()
        } else if (e.data.start === 1) {
          this.$message("首次登录请绑定微信");
          this.switchType = 1;
          this.towShow = false;
        } else if (e.data.start === 2) {
          this.$message("首次登录请绑定手机");
          this.switchType = 2;
          this.towShow = false;
        } else {
          this.$message.error(e.data.error);
        }
      });
    },
    clearURLParams() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      // 清空所有参数
      params.forEach((value, key) => {
        params.delete(key);
      });

      // 更新 URL
      window.history.replaceState(
        {},
        "",
        `${url.pathname}?${params.toString()}`
      );
    },
  },
};
</script>
<style lang="css" scoped>
@keyframes show1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fade1 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.show {
  animation: show1 0.5s linear forwards;
}
.fade {
  animation: fade1 0.5s linear forwards;
}
.image-box {
  width: 100%;
  height: 100%;
  text-align: center;
}
.loginText {
  font-size: 18px;
}
.switch {
  text-align: right;
  color: #0077ed;
  padding-right: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.phoneBox {
  height: 405px;
}
.title {
  text-align: center;
  font-size: 20px;
  color: #333;
}
.content {
  height: 370px;
  padding: 0 15px;
  /* background-color: #f00; */
}
.input1 {
  height: 55px;
  width: 98%;
  padding-left: 15px;
  font-size: 15px;
  border-radius: 4px;
  border: none;
  background-color: #f6f6f6;
}
.input2 {
  height: 55px;
  width: 265px;
  padding-left: 15px;
  font-size: 15px;
  border-radius: 4px 0px 0px 4px;
  border: none;
  background-color: #f6f6f6;
}
input:focus {
  outline: 2px solid #0077ed;
}
.input2:focus {
  width: 263px;
}
.codeBox {
  display: flex;
  justify-content: space-between;
}

.btn1 {
  display: inline-block;
  height: 55px;
  width: 148px;
  background-color: #0077ed;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-radius: 0px 4px 4px 0px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.btnFade {
  opacity: 0.7;
}

.btn2 {
  height: 55px;
  width: 100%;
  background-color: #0077ed;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-radius: 4px;
  margin-top: 40px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.height0 {
  height: 0px;
  overflow: hidden;
}
.tips {
  margin-bottom: -10px;
  margin-top: 30px;
  text-align: center;
  font-size: 10px;
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue